import { render } from "./PauseCircle.vue?vue&type=template&id=6b38d3c8"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PauseCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b38d3c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b38d3c8', __exports__)) {
    api.reload('6b38d3c8', __exports__)
  }
  
  module.hot.accept("./PauseCircle.vue?vue&type=template&id=6b38d3c8", () => {
    api.rerender('6b38d3c8', render)
  })

}


export default __exports__